import { ArrowLeft, Ellipsis } from "lucide-react";
import {
  selectConversations,
  selectCurrConversation,
  setCurrConversation,
} from "@/features/control/controlSlice";
import {
  selectIsDetailsPaneOpen,
  toggleIsDetailsPaneOpen,
} from "@/features/details/detailsSlice";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";

import { Conversation } from "../../types/conversation";
import { Toggle } from "@/components/ui/toggle";
import { processFullname } from "@/utils/utils";

const ChatHeader = () => {
  const dispatch = useAppDispatch();
  const conversations: Conversation[] = useAppSelector(selectConversations);
  const currConversationIndex = useAppSelector(selectCurrConversation);
  const isDetailsPaneOpen = useAppSelector(selectIsDetailsPaneOpen);
  const currConversation =
    currConversationIndex != null ? conversations[currConversationIndex] : null;
  const fullname = currConversation?.fullname || "";
  const groupName = currConversation?.groupName || "";
  const [username, name] = processFullname(fullname, groupName);

  return (
    <div className="flex items-start justify-between gap-2 mb-2 pb-2 border-b border-neutral-300">
      {/* Mobile-only: single-pane layout needs a way back to the conversation list */}
      <button
        onClick={() => dispatch(setCurrConversation(null))}
        className="p-2 rounded-md hover:bg-accent md:hidden shrink-0"
        aria-label="Back to conversations"
      >
        <ArrowLeft size={20} />
      </button>
      <p id="chat-header-name" className="flex-1 text-xl font-light min-w-0 [overflow-wrap:anywhere]">
        <span className="font-semibold">{username}</span>
        {name}
      </p>
      {/* Delete lives in the details pane ("..."), next to Search and Members. */}
      <div className="flex items-center justify-center shrink-0">
        <Toggle
          size="sm"
          pressed={isDetailsPaneOpen}
          onPressedChange={() => dispatch(toggleIsDetailsPaneOpen())}
        >
          <Ellipsis className="w-5 h-5" />
        </Toggle>
      </div>
    </div>
  );
};

export default ChatHeader;
